interface CloseCircleIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const CloseCircleIcon: React.FC<CloseCircleIconProps> = ({ 
  className = "", 
  width = 20, 
  height = 20 
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="15" y1="9" x2="9" y2="15"></line>
      <line x1="9" y1="9" x2="15" y2="15"></line>
    </svg>
  );
};

export default CloseCircleIcon;

